/* eslint-disable react/no-multi-comp */
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { toRoman } from 'helpers'

export const DOESNT_HAVE_N_LEVEL_VEHICLE = level => (
    <FormattedMessage
        id="players_matching.no_vehicles_of_level"
        defaultMessage="У вас нет техники {level} уровня."
        values={{ level: toRoman(level) }}
    />
)

export const NEEDED_VEHICLES_OF_LEVEL = level => (
    <FormattedMessage
        id="players_matching.needed_vehicles_of_level"
        defaultMessage="Сражения в режиме «Вылазки {level}» доступны только на технике {level} уровня."
        values={{ level: toRoman(level) }}
    />
)



// WEBPACK FOOTER //
// ./containers/BattleRooms/containers/PlayersMatchingView/components/NoVehicles/translations.js